import { render, staticRenderFns } from "./PendingInvitesCard.vue?vue&type=template&id=38775a32&scoped=true&"
import script from "./PendingInvitesCard.vue?vue&type=script&lang=ts&"
export * from "./PendingInvitesCard.vue?vue&type=script&lang=ts&"
import style0 from "./PendingInvitesCard.vue?vue&type=style&index=0&id=38775a32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38775a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
